import PropTypes from "prop-types";
import BaseComponent from "../../../../lib/components/BaseComponent";
import {createRef} from "react";
import DataType from "../../../../lib/model/types/DataType";

class SimpleSearchHeaderCell extends BaseComponent {

    constructor(props) {
        super(props);
        this.fieldRef = createRef();
    }

    render() {
        const {label, field, fieldType, value, fieldGenerator} = this.props;

        // Erzeugt je Datentyp das passende Such-Feld (Dropdown, Checkbox, DatePicker, Text, ...)
        // über den gemeinsam mit dem erweiterten Filter genutzten SimpleFilterFieldGenerator.
        // Ohne bekannten Feldtyp wird auf ein einfaches Textfeld zurückgefallen.
        let inputField = null;
        if (fieldGenerator) {
            inputField = fieldGenerator.initField(fieldType || {type: DataType.STRING}, field, value, null,
                this.fieldRef);
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                <div className="MuiDataGrid-columnHeaderTitle">
                    {label}
                </div>
                <div style={{width: '100%'}}>
                    {inputField}
                </div>
            </div>
        );
    }
}

SimpleSearchHeaderCell.propTypes = {
    label: PropTypes.string,
    field: PropTypes.string,
    fieldType: PropTypes.any,
    value: PropTypes.any,
    fieldGenerator: PropTypes.any,
}
export default  SimpleSearchHeaderCell
